var map = {
	"./align-strategy.svg": "94ec",
	"./artificial-intelligence.svg": "2397",
	"./business-intelligence.svg": "3d59",
	"./commercial-alignment.svg": "b48a",
	"./custom-visuals.svg": "cae1",
	"./data-education.svg": "d7f3",
	"./data-ethics.svg": "b007",
	"./data-science.svg": "115a",
	"./external-data.svg": "7fd9",
	"./hands-on.svg": "cf17",
	"./internal-data.svg": "a6a0",
	"./perpetuating-innovation.svg": "e0df",
	"./privacy-policy.svg": "786a",
	"./security-policy.svg": "cc55",
	"./speed-iteration.svg": "cab3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1cef";